import { DecimalPipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { InformacionTarea } from 'src/app/domain/model/orden-servicio/orden-servicio';

/**
 * Componente dumb: tabla de resultados y paginacion manual del modulo
 * Informacion de Tareas.
 *
 * Legacy: InformacionTareasViewImpl (grilla de resultados)
 */
@Component({
  selector: 'app-tabla-informacion-tareas',
  standalone: true,
  imports: [DecimalPipe, FormsModule, ButtonModule, CardModule, DropdownModule, TableModule, TagModule, TooltipModule],
  styleUrls: ['../../../shared/styles/grid-table.styles.scss'],
  template: `
    <p-card class="mb-4">
      <ng-template pTemplate="header">
        <div class="p-3 pb-0 flex justify-between items-center">
          <h3 class="text-lg font-semibold text-gray-700 dark:text-gray-200 m-0">Listado de Orientaciones</h3>
          @if (totalRegistros() > 0) {
            <span class="text-sm text-gray-500 dark:text-gray-400">
              Registros del {{ registroInicio() }} hasta el {{ registroFin() }} de {{ totalRegistros() }}
            </span>
          }
        </div>
      </ng-template>

      <div class="md:hidden space-y-3">
        @if (items().length === 0 && !consultando()) {
          <div class="text-center p-4 text-gray-500 dark:text-gray-400 border border-gray-200 dark:border-gray-700 rounded-lg">
            No se encontraron registros
          </div>
        }

        @for (item of items(); track $index) {
          <div class="border border-gray-200 dark:border-gray-700 rounded-lg p-3 bg-white dark:bg-gray-900">
            <div class="grid grid-cols-1 gap-2 text-sm">
              <div><span class="text-gray-500">Orientación:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.orden || '-' }}</span></div>
              <div><span class="text-gray-500">Prioridad:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.snprioridad === 'S' ? 'ALTA' : 'Normal' }}</span></div>
              <div><span class="text-gray-500">Empresa:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.beneficiario || '-' }}</span></div>
              <div><span class="text-gray-500">Producto:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dsproducto || '-' }}</span></div>
              <div><span class="text-gray-500">Tarea:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.tarea || '-' }}</span></div>
              <div><span class="text-gray-500">Clasificación:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.clasificacion || '-' }}</span></div>
              <div><span class="text-gray-500">Saldo programar:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.saldoProgramar ?? 0 | number:'1.0-2' }}</span></div>
              <div><span class="text-gray-500">Saldo ejecutar:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.saldoEjecutar ?? 0 | number:'1.0-2' }}</span></div>
              <div><span class="text-gray-500">Fecha entrega:</span> <span class="text-gray-800 dark:text-gray-200">{{ formatDate(item.feentrega) }}</span></div>
              <div><span class="text-gray-500">No. llamadas:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.nroLlamadas ?? 0 }}</span></div>
              <div><span class="text-gray-500">Estado SGS:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.estadoOc || '-' }}</span></div>
            </div>

            <div class="mt-3">
              <p-button
                label="Ver detalle"
                icon="pi pi-search"
                size="small"
                styleClass="w-full min-h-[44px]"
                (onClick)="seleccionar.emit(item)">
              </p-button>
            </div>
          </div>
        }
      </div>

      <div class="hidden md:block">
      <p-table
        [resizableColumns]="true"
        columnResizeMode="expand"
        [value]="items()"
        [paginator]="false"
        [rows]="pageSize()"
        [loading]="consultando()"
        responsiveLayout="scroll"
        styleClass="tabla-informacion-tareas p-datatable-sm p-datatable-gridlines"
        [scrollable]="true"
        [tableStyle]="{ 'min-width': '72rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th pResizableColumn><span class="grid-header-text" title="Orientación">Orientación</span></th>
            <th pResizableColumn>Prioridad</th>
            <th pResizableColumn><span class="grid-header-text" title="Empresa">Empresa</span></th>
            <th pResizableColumn><span class="grid-header-text" title="Producto">Producto</span></th>
            <th pResizableColumn><span class="grid-header-text" title="Tarea">Tarea</span></th>
            <th pResizableColumn><span class="grid-header-text" title="Clasificacion">Clasificacion</span></th>
            <th pResizableColumn class="text-right"><span class="grid-header-text" title="Saldo por programar">Saldo por programar</span></th>
            <th pResizableColumn class="text-right"><span class="grid-header-text" title="Saldo por ejecutar">Saldo por ejecutar</span></th>
            <th pResizableColumn>Fecha entrega</th>
            <th pResizableColumn class="text-center"><span class="grid-header-text" title="No.Llamadas (Excepto cancelacion)">No.Llamadas (Excepto cancelacion)</span></th>
            <th pResizableColumn><span class="grid-header-text" title="Estado SGS">Estado SGS</span></th>
            <th pResizableColumn class="text-center" style="width: 110px">Acciones</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.orden }}</td>
            <td>
              @if (item.snprioridad === 'S') {
                <p-tag severity="danger" value="ALTA"></p-tag>
              } @else {
                <span class="text-gray-500 dark:text-gray-400">Normal</span>
              }
            </td>
            <td><span class="grid-cell-text" [attr.title]="item.beneficiario || '-'">{{ item.beneficiario || '-' }}</span></td>
            <td><span class="grid-cell-text" [attr.title]="item.dsproducto || '-'">{{ item.dsproducto || '-' }}</span></td>
            <td><span class="grid-cell-text" [attr.title]="item.tarea || '-'">{{ item.tarea || '-' }}</span></td>
            <td><span class="grid-cell-text" [attr.title]="item.clasificacion || '-'">{{ item.clasificacion || '-' }}</span></td>
            <td class="text-right">{{ item.saldoProgramar ?? 0 | number:'1.0-2' }}</td>
            <td class="text-right">{{ item.saldoEjecutar ?? 0 | number:'1.0-2' }}</td>
            <td>{{ formatDate(item.feentrega) }}</td>
            <td class="text-center">{{ item.nroLlamadas ?? 0 }}</td>
            <td><span class="grid-cell-text" [attr.title]="item.estadoOc || '-'">{{ item.estadoOc || '-' }}</span></td>
            <td class="text-center">
              <button
                pButton
                icon="pi pi-search"
                class="p-button-rounded p-button-text p-button-sm p-button-primary min-w-[44px] min-h-[44px]"
                pTooltip="Ver detalle de la orden"
                (click)="seleccionar.emit(item)">
              </button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="12" class="text-center p-6 text-gray-500 dark:text-gray-400">
              No se encontraron registros
            </td>
          </tr>
        </ng-template>
      </p-table>
      </div>

      @if (totalRegistros() > 0) {
        <div class="flex justify-between items-center p-3 border-t border-gray-200 dark:border-gray-700 mt-2">
          <div class="text-gray-600 dark:text-gray-300 text-sm">
            Pagina {{ currentPage() }} de {{ totalPages() }}
          </div>
          <div class="flex gap-2 items-center flex-wrap justify-end sm:justify-start">
            <label class="text-sm text-gray-600 dark:text-gray-300">Registros:</label>
            <p-dropdown
              [options]="pageSizeOptions()"
              [ngModel]="selectedPageSize()"
              (ngModelChange)="cambiarTamanoPagina.emit($event)"
              appendTo="body"
              [style]="{ width: '80px' }">
            </p-dropdown>
            <button
              pButton
              icon="pi pi-angle-double-left"
              class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
              pTooltip="Primera pagina"
              [disabled]="currentPage() <= 1"
              (click)="irPrimeraPagina.emit()">
            </button>
            <button
              pButton
              icon="pi pi-angle-left"
              class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
              pTooltip="Anterior"
              [disabled]="!hasPrevious()"
              (click)="irPaginaAnterior.emit()">
            </button>
            <button
              pButton
              icon="pi pi-angle-right"
              class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
              pTooltip="Siguiente"
              [disabled]="!hasNext()"
              (click)="irPaginaSiguiente.emit()">
            </button>
            <button
              pButton
              icon="pi pi-angle-double-right"
              class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
              pTooltip="Ultima pagina"
              [disabled]="currentPage() >= totalPages()"
              (click)="irUltimaPagina.emit()">
            </button>
          </div>
        </div>
      }
    </p-card>
  `
})
export class TablaInformacionTareasComponent {
  items = input<InformacionTarea[]>([]);
  consultando = input(false);
  pageSize = input(10);
  totalRegistros = input(0);
  registroInicio = input(0);
  registroFin = input(0);
  currentPage = input(1);
  totalPages = input(0);
  hasNext = input(false);
  hasPrevious = input(false);
  pageSizeOptions = input<number[]>([]);
  selectedPageSize = input(10);

  seleccionar = output<InformacionTarea>();
  cambiarTamanoPagina = output<number>();
  irPrimeraPagina = output<void>();
  irPaginaAnterior = output<void>();
  irPaginaSiguiente = output<void>();
  irUltimaPagina = output<void>();

  /**
   * Legacy: InformacionTareasViewImpl formatea la fecha de entrega con
   * DateTimeFormat.getFormat("yyyy/MM/dd"). Se replica el mismo formato.
   */
  formatDate(value?: string): string {
    if (!value) {
      return '-';
    }

    const [year, month, day] = value.split('-').map((part) => Number(part));
    if (!year || !month || !day) {
      return value;
    }

    return `${year}/${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}`;
  }
}
